/** @format */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import classNames from 'classnames';
import Chip from '@material-ui/core/Chip';

import { Storage, API } from 'aws-amplify';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import defaultImg from './icon-user-default.png';
import { LIST_MEMBERS_BY_EMAIL } from '../../common/graphql/ListMembersByEmail';
import { useQuery } from 'react-apollo-hooks';

const styles = theme => ({
  rootInline: {
    display: 'inline-block'
  },
  root: { padding: 15 },
  rootFluid: { width: '100%' },
  rootOpaque: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.light
  },
  error: {
    color: 'red'
  },
  avatar: {
    margin: 10,
    display: 'inline-block',
    width: 30,
    height: 30
  },
  inlineDetails: {
    display: 'inline-block',
    verticalAlign: 'top',
    marginTop: 10,
    textAlign: 'left'
  },
  inlineName: {
    display: 'block',
    fontWeight: 'bold'
  },
  inlineTitle: {
    fontSize: 'x-small',
    color: 'grey'
  },
  focusVisible: {},
  wrapper: {
    margin: 10,
    borderRadius: 20,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },
    '& > div': {
      padding: 5,
      paddingBottom: 0,
      paddingTop: 0
    }
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60
  }
});

const UserCard = props => {
  const {
    id,
    classes,
    fluid,
    align,
    user: rawUser,
    inline,
    transparent,
    compact,
    fromEmail,
    onLoad,
    showStoreName = false
  } = props;
  const { memberInfo } = rawUser;

  const [avatarImg, setAvatarImg] = React.useState(defaultImg);

  const { data: queryData } = useQuery(LIST_MEMBERS_BY_EMAIL.query, {
    variables: {
      email: fromEmail
    },
    skip: !fromEmail
  });
  const fromEmailData = get(queryData, 'listMembers.items.0');
  const emailNotFound = fromEmail && !fromEmailData;

  const contactInfo = fromEmailData || memberInfo || rawUser;

  React.useEffect(() => {
    const errors = [];
    if (emailNotFound) {
      errors.push('No match for member with email: ' + fromEmail);
    }
    onLoad && onLoad({ errors, user: contactInfo });
  }, [fromEmailData, contactInfo, emailNotFound, onLoad, fromEmail]);
  const user = {
    ...rawUser,
    ...memberInfo,
    ...contactInfo,
    fullName: `${contactInfo.firstName ||
      contactInfo.given_name} ${contactInfo.lastName || contactInfo.family_name}`,
    title:
      get(memberInfo, 'role.name') ||
      get(contactInfo, 'role.name') ||
      get(rawUser, 'role.name') ||
      'no-title'
  };
  React.useEffect(() => {
    let unmounted = false;
    const aImgKey = get(user, 'avatar.filename');
    if (!aImgKey) return;
    Storage.get(aImgKey).then(imgUrl => {
      if (unmounted) return;
      setAvatarImg(imgUrl);
    });
    return () => {
      unmounted = true;
    };
  }, [user, user.avatar]);
  const isAdmin = get(user, 'role.group') === 'Admins';
  const userStoreName = isAdmin || !showStoreName ? null : get(user, 'store.name');
  const customStyle = {};
  if (align) {
    customStyle.textAlign = align;
  }
  // eslint-disable-next-line react/no-multi-comp
  function renderStatus() {
    const isInactive = get(rawUser, 'inactive') === true;
    if (isInactive)
      return (
        <div>
          <Chip label="Inactive" />
        </div>
      );
    return null;
  }
  if (emailNotFound)
    return (
      <div className={classes.error}>
        Email not found: <strong>{fromEmail}</strong>
      </div>
    );
  return (
    <div
      id={id}
      className={classNames(classes.root, {
        [classes.rootInline]: inline,
        [classes.rootOpaque]: !transparent,
        [classes.rootFluid]: fluid
      })}>
      <center>
        <div style={{ ...customStyle }}>
          {!compact && (
            <Avatar
              onClick={async () => {
                const x = await API.post('cmiLoginByCode', '/code', {
                  headers: { 'Content-Type': 'application/json' },
                  body: {
                    code: 'sdfdsf'
                  }
                });
                console.log('>>ImportPage/index::', 'x', x); //TRACE
              }}
              alt={startCase(get(user, 'fullName'))}
              src={avatarImg || defaultImg}
              className={inline ? classes.avatar : classes.bigAvatar}
            />
          )}
          {inline && (
            <div className={classes.inlineDetails}>
              <span className={classes.inlineName}>
                {startCase(get(user, 'fullName'))}
              </span>
              <span className={classes.inlineTitle}>
                {get(user, 'title')}
                {userStoreName && (
                  <>
                    {'  '}({userStoreName})
                  </>
                )}
              </span>
            </div>
          )}
        </div>
        {!inline && (
          <>
            <div>
              <Typography variant="subtitle1" gutterBottom color="inherit">
                {get(user, 'fullName')}
              </Typography>
            </div>
            <div>
              <Typography variant="caption" gutterBottom color="inherit">
                {get(user, 'title')}
                {userStoreName && (
                  <>
                    {'  '}({userStoreName})
                  </>
                )}
              </Typography>
            </div>
          </>
        )}
        {renderStatus()}
      </center>
    </div>
  );
};

// eslint-disable-next-line react/no-multi-comp
const Wrapper = props => {
  const { clickable, onClick } = props;

  if (!clickable) return <UserCard {...props} />;
  function clickHandler() {
    onClick && onClick(props.user);
  }
  return (
    <ButtonBase
      focusRipple
      className={props.classes.wrapper}
      focusVisibleClassName={props.classes.focusVisible}
      onClick={clickHandler}>
      <UserCard {...props} />
    </ButtonBase>
  );
};
export default withStyles(styles, { withTheme: true })(Wrapper);
